import { StringUtil } from './string.util';

export class ObjectUtil {
	static isEquals(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}

	static isEmpty(obj: any): boolean {
		if (!obj) {
			return true;
		}
		return !Object.keys(obj).length || !Object.keys(obj).some(key => !!obj[key]);
	}

	static isObject(obj): boolean {
		return Object.prototype.toString.call(obj) === '[object Object]';
	}

	static isArrayOfObject(array: any[]): boolean {
		if (!Array.isArray(array)) {
			return false;
		}
		return array.some(it => ObjectUtil.isObject(it));
	}

	/**
	 *  Converts keys to lowercase, detects object values and sends them off for further conversion
	 */
	private static keyMapper([key, val]): [any, any] {
		const keyCamel = StringUtil.snakeToCamel(key);

		if (ObjectUtil.isObject(val)) {
			return [keyCamel, ObjectUtil.lowerCaseKey(val)];
		} else if (ObjectUtil.isArrayOfObject(val)) {
			return [keyCamel, val.map(it => ObjectUtil.lowerCaseKey(it))];
		}

		return [keyCamel, val];
	}

	/**
	 * The entry point for recursion, iterates and maps object properties
	 * NEW METHOD: Object.fromEntries(Object.entries(obj).map(ObjectUtil.keyMapper))
	 */
	private static lowerCaseKey(obj) {
		return Object.entries(obj)
			.map(ObjectUtil.keyMapper)
			.reduce((acc, [k, v]) => ((acc[k] = v), acc), {});
	}

	static snakeToCamel(object: any) {
		return ObjectUtil.lowerCaseKey(object);
	}
}
